export const unescapeHTML = (expression: string) =>
  expression
    ?.replace(/&Auml;/g, 'Ä')
    .replace(/&auml;/g, 'ä')
    .replace(/&Euml;/g, 'Ë')
    .replace(/&euml;/g, 'ë')
    .replace(/&Iuml;/g, 'Ï')
    .replace(/&iuml;/g, 'ï')
    .replace(/&Ouml;/g, 'Ö')
    .replace(/&ouml;/g, 'ö')
    .replace(/&Uuml;/g, 'Ü')
    .replace(/&uuml;/g, 'ü')
    .replace(/&szlig;/g, 'ß');
